import { lighten, Theme } from '@mui/material';

export const getGradientShadow = (theme: string) => {
  return theme === 'dark'
    ? 'linear-gradient(90deg, rgba(30, 30, 30, 0.8) 0%, rgba(50, 50, 50, 0.8) 100%)'
    : 'linear-gradient(90deg, rgba(214, 222, 226, 0.2) 0%, rgba(214, 222, 226, 0.5) 100%)';
};

export const minimalScrollbarStyling = {
  '&::-webkit-scrollbar, & ::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track, & ::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb, & ::-webkit-scrollbar-thumb': {
    background: '#666',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover, & ::-webkit-scrollbar-thumb:hover': {
    background: '#888',
  },
  scrollbarColor: '#666 transparent',
};

/**
 * When using tabs, on mobile sizing - convert to a dropdown
 */
export const tabSelectDropdownStyling = (theme: Theme) => ({
  backgroundColor: theme.palette.custom.overlay.selected,
  color: theme.palette.primary.main,
  '& .MuiSelect-select': {
    color: theme.palette.primary.main,
    fontWeight: 600,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    height: 'auto', // Allow to fill space instead of restricting to 48px
  },
  '& .MuiSelect-icon': {
    color: theme.palette.primary.main,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    display: 'none',
  },
  '& .MuiOutlinedInput-root': {
    border: 'none',
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    display: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    display: 'none',
  },
});

export const brandedLinkColor = (theme: Theme) =>
  theme.palette.mode === 'dark'
    ? lighten(theme.palette.primary.main, 0.28)
    : theme.palette.primary.main;
